var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoSquareBlack = function SvgLogoSquareBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.953 77H.512V.694H78v62.259C78 70.71 71.712 77 63.953 77",
    fill: "#121212"
  })));
};
export { SvgLogoSquareBlack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzgiIGhlaWdodD0iNzciIHZpZXdCb3g9IjAgMCA3OCA3NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02My45NTI4IDc2Ljk5OThIMC41MTE4NzFWMC42OTM4NDhINzhWNjIuOTUyN0M3OCA3MC43MDk1IDcxLjcxMTcgNzYuOTk5OCA2My45NTI4IDc2Ljk5OTgiIGZpbGw9IiMxMjEyMTIiLz4KPC9zdmc+Cg==";